import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrLyaLiveNote, JoinEvent, LLNote } from '../state/meetcall.types';
@Injectable({
  providedIn: 'root',
})
export class MeetCallService {
  constructor(private http: HttpClient) {}

  joinEvent(companyId: string, linkData: string): Observable<JoinEvent> {
    return this.http.post<JoinEvent>(
      '/lya/live-interview-p/join',
      null, // no request body
      {
        headers: {
          company_id: companyId,
        },
        params: {
          linkData,
        },
      },
    );
  }

  saveComment(data: CrLyaLiveNote, linkData: string, companyId: string): Observable<LLNote> {
    return this.http.post<LLNote>(`/lya/live-interview-p/save-note`, data, {
      headers: { company_id: companyId },
      params: { linkData },
    });
  }

  completeInterview(companyId: string, linkData: string): Observable<void> {
    return this.http.post<void>('/lya/live-interview-p/complete', null, {
      headers: { company_id: companyId },
      params: { linkData },
    });
  }
}
